import { ofType } from "redux-observable";
import { from, merge, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { selectWorkersInfo } from "../../../../selectors/selectWorkersInfo";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { utilNumber } from "../../../../utils/utilNumber";
import { IdCharacterHelpType } from "../../../character-help-dialog/IdCharacterHelpType";
import { actionBaseInfoAddBuilding, actionBaseInfoRemoveBuilding, } from "../../../info/base/actionBaseInfo";
import { actionInventoryInfoAddResource } from "../../../info/inventory/actionInventoryInfo";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionOngoingPurchaseCharacterHelpSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { actionBuildingsCancelMove, actionBuildingsDeselect, TypeActionBuildings, } from "../actionBuildings";
export var epicBuildingsDemolish = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.Demolish), switchMap(function (action) {
        var state = state$.value;
        var currentWorkers = selectWorkersInfo(state);
        var _a = action.building, proto = _a.proto, balancing = _a.balancing;
        var selectedStage = proto.stage ? balancing.stage[proto.stage] : undefined;
        if (selectedStage && currentWorkers.free - selectedStage.workers < 0) {
            var missingWorker = currentWorkers.free - selectedStage.workers;
            return from([
                actionBuildingsCancelMove(),
                actionOngoingPurchaseCharacterHelpSelect({
                    missing: utilNumber.format(missingWorker),
                    type: IdCharacterHelpType.MissingWorkers,
                }),
                actionModalOpen(IdModal.CharacterHelp),
            ]);
        }
        var request$ = deps
            .netSend({
            id: CommandCode.Demolish,
            props: {
                buildingId: proto.id,
                farmId: state.playerBase.base.baseId,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(switchMap(function (res) {
            return of(actionInventoryInfoAddResource(res.refund));
        }), catchError(function () { return of(actionBaseInfoAddBuilding(proto)); }));
        return merge(request$, of(actionBuildingsDeselect()), of(actionBaseInfoRemoveBuilding(proto)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsDemolish.ts
// module id = 2052
// module chunks = 3